

//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  

/**
  * Fee Categories (these match up to the row ID in dbo.FeeCategory table)
  */
enum FeeCategory {

  /**
   * Fee associated with a reservation.
   */
  Reservation = 1,

  /**
   * Fee associated with the subscription.
   */
  Subscription = 2,

  /**
   * Fee for ordering a background check for a new member.
   */
  BackgroundCheck = 3,

}

export default FeeCategory;